import { EMAIL_PERSONAL_LINK_HREF, type Prospect } from '@immo/api-contract';

export const PERSONAL_LINK_ATTRIBUTE = 'data-personal-link';

const PERSONAL_LINK_SELECTOR = `[${PERSONAL_LINK_ATTRIBUTE}]`;
const CHIP_CLASS =
  'mx-0.5 inline-flex items-center rounded-sm border border-border bg-subtle px-1 font-mono text-xs text-text-secondary';

/**
 * The unmarked chip „Link zur persönlichen Seite“ (IMM-1177.7, PRD Detailed AC 35). It does not block sending; the
 * link itself is issued by the backend at sending and never shown here.
 */
export function createPersonalLinkChip(text: string): HTMLSpanElement {
  const chip = document.createElement('span');

  chip.setAttribute(PERSONAL_LINK_ATTRIBUTE, '');
  chip.setAttribute('contenteditable', 'false');
  chip.className = CHIP_CLASS;
  chip.textContent = text;

  return chip;
}

/** An Interessent has a personal page once their Widerrufsbelehrung went out at least once (IMM-1065). */
export function hasPersonalPage(prospect: Prospect | null): boolean {
  return prospect !== null && prospect.brokerageAgreement.notice.sentAt !== null;
}

/**
 * The body as sent: each personal-link chip becomes an anchor whose `href` the backend swaps for the issued link.
 * `hasPersonalLink` says whether the send must name the Interessent.
 */
export function toSendableBody(
  html: string,
  linkText: string,
): { readonly html: string; readonly hasPersonalLink: boolean } {
  const template = document.createElement('template');

  template.innerHTML = html;

  const chips = Array.from(template.content.querySelectorAll(PERSONAL_LINK_SELECTOR));

  if (chips.length === 0) return { html, hasPersonalLink: false };

  for (const chip of chips) {
    const anchor = document.createElement('a');

    anchor.setAttribute('href', EMAIL_PERSONAL_LINK_HREF);
    anchor.textContent = linkText;
    chip.replaceWith(anchor);
  }

  return { html: template.innerHTML, hasPersonalLink: true };
}
